var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.configuration.login == 'ky')?_c('Ky'):(_vm.configuration.login == 'zhp')?_c('Zhp'):(_vm.configuration.login == 'wf')?_c('Wf'):_c('Common')],1)}
var staticRenderFns = []

export { render, staticRenderFns }